var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['filters-field-wrapper unselectable', {}],attrs:{"tabindex":"-1","ontouchstart":""},on:{"focus":_vm.onFocus,"blur":_vm.onBlur}},[_c('div',{class:[
      ' d3-card _button',
      {
        __focus: _vm.input_focus
      }
    ],on:{"click":_vm.toggleDropdown}},[_c('div',{staticClass:"_value"},[(!_vm.input_selected)?[_vm._v(_vm._s(_vm.text))]:[_vm._v("Filtering by "+_vm._s(_vm.input_selected))]],2),_c('d3-icon',{staticClass:"icon ion-ios-arrow-down"})],1),_c('ul',{class:[
      'd3-card _dropdown',
      {
        __visible: _vm.dropdown_visible
      }
    ]},_vm._l((_vm.options),function(option,index){return _c('li',{key:index,staticClass:"_dropdown-item",attrs:{"ontouchstart":""},on:{"click":function($event){return _vm.onChange(option)}}},[_vm._v(" "+_vm._s(option.text)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }